module.exports = __webpack_public_path__ + "img/err.f6a0060a.png";